<template>
  <w-form-table :model="model" v-bind="_props" :floating-header="true">
    <template v-slot:thead>
      <slot name="thead">
        <slot name="beforeThead" />

        <w-thead v-if="isThead" v-bind="_props">
          <template v-slot:Lp>
            <slot name="th_Lp" />
          </template>

          <template v-for="slot in thSlots" :slot="slot.substring(3)" slot-scope="{property, propertyName}">
            <slot :name="slot" :property="property" :property-name="propertyName" />
          </template>

          <template v-slot:RowBtns>
            <slot name="th_RowBtns" />
          </template>
        </w-thead>

        <slot name="afterThead" />
      </slot>
    </template>

    <slot name="beforeTbody" />

    <slot name="tbody">
      <w-tbody v-bind="_props" :colspan="addRowColspan">
        <template slot="beforeTblock" slot-scope="{item}">
          <slot name="beforeTblock" :item="item" />
        </template>

        <template v-slot:Lp>
          <slot name="Lp" />
        </template>

        <template v-for="slot in tbSlots" :slot="slot" slot-scope="{item, property, propertyName}">
          <slot :name="slot" :item="item" :property="property" :property-name="propertyName" />
        </template>

        <template v-slot:RowBtns>
          <slot name="RowBtns" />
        </template>

        <template slot="afterTblock" slot-scope="{item}">
          <slot name="afterTblock" :item="item.$item" />
        </template>
      </w-tbody>
    </slot>

    <slot name="afterTbody" />

    <slot name="tfoot">
      <tfoot v-if="modelSum">
        <w-tblock :model="modelSum" :properties-count="flatProperties.length" v-bind="_props" prefix="tf_">
          <template v-slot:Lp>
            <slot name="tf_Lp" />
          </template>

          <template v-for="slot in tfSlots" :slot="slot.substring(3)" slot-scope="{item, property, propertyName}">
            <slot :name="slot" :item="item" :property="property" :property-name="propertyName" />
          </template>

          <template v-slot:RowBtns>
            <slot name="tf_RowBtns" />
          </template>
        </w-tblock>
      </tfoot>
    </slot>
  </w-form-table>
</template>

<script>
import tableMixin from '../mixins/tableMixin';

import WFormTable from './form-table.vue';
import WThead from './thead.vue';
import WTbody from './tbody.vue';
import WTblock from './tblock.vue';

export default {
  name: 'w-schema-table',
  components: {WFormTable, WThead, WTbody, WTblock},
  mixins: [tableMixin],
  props: {
    modelSum: {
      type: Object,
      required: false
    },
    addRowColspan: {
      type: Number,
      default: 0
    },
    isThead: {
      type: Boolean,
      default: true
    },
    margin: {
      type: Boolean,
      default: true
    }
  }
};
</script>
